import $  from 'jquery';

export const showMobileMenu = () => {
    $('.js-mob-catalog').on('click', function () {
        $('.js-modal-catalog').toggleClass('active');
    })
}
